import { render, staticRenderFns } from "./addPhysicalInfoForm.vue?vue&type=template&id=36db4fd6"
import script from "./addPhysicalInfoForm.vue?vue&type=script&lang=js"
export * from "./addPhysicalInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports